import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import RedirectPage from "./services/Redirect";
import { getUser } from "./services/Authservice";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Notes from "./Pages/NotesPage/NotesPage";
import VideoPlayer from "./Pages/VideoPlayer/VideoPlayer";
import LandingPage from "./Pages/Dashboard/Landing";
import SearchPage from "./Pages/SearchPage/SearchPage";
import LandingHomePage from "./Pages/Home/LandingHomePage";

export default function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: "#facc15",
          colorBgBase: "#17142f",
          colorTextBase: "#f8f7fc",
          borderRadius: 12,
          fontFamily: "inherit",
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingHomePage />} />
          <Route path="/dashboard" element={<Home />} />
          <Route path="/video-player" element={<VideoPlayer />} />
          <Route path="/explore-video" element={<VideoPlayer />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/loginredirect" element={<RedirectPage />} />
          <Route path="*" element={<LandingHomePage />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

function Home() {
  return getUser() ? <Dashboard /> : <LandingPage />;
}
